// userData
export const userData = {
  id:'233333',
  name:'name233',

}


// nodePath 

export const logicInfo1 = {
  endAction:{
    type:'openUrl',
    params:{
      url:'https://www.baidu.com'
    }
  },
  rootNode : {
    id:'start_1',
    nodeType:'startNode',
    priority:1,
    name:'开始',
    action:'useStart',

    branch:[{
      name:'登录验证',
      id:'judgeNode_1',
      nodeType:'businessNode',
      action:'useUserLogin',
      // 拖拽后进行配置branch
      branch:[
        {
          name:'用户登录',
          id:'businessNode_1_0',
          nodeType:'businessNode',
          action:'getUserInfo',
          // 拖拽后进行配置branch
          branch:[
            {
              name:'结束',
              id:'endNode_1_0',
              nodeType:'endNode',
              action:'useGetLotteryEligibility',
              // 拖拽后进行配置branch
              branch:[
                
              ],
              
            },
          ],          
        },
        {
          name:'获取抽奖资格',
          id:'businessNode_1',
          nodeType:'businessNode',
          action:'useGetLotteryEligibility',
          // 拖拽后进行配置branch
          branch:[
            {
              name:'抽奖路径1',
              id:'businessNode_1_1',
              nodeType:'businessNode',
              action:'useGetLotteryEligibility',
              // 拖拽后进行配置branch
              branch:[
                {
                  name:'结束',
                  id:'endNode_1',
                  nodeType:'endNode',
                  action:'useGetLotteryEligibility',
                  // 拖拽后进行配置branch
                  branch:[
                    
                  ],
                  
                },
              ],
              
            },
            {
              name:'抽奖路径2',
              id:'businessNode_1_2',
              nodeType:'businessNode',
              action:'useGetLotteryEligibility',
              // 拖拽后进行配置branch
              branch:[
                {
                  name:'结束',
                  id:'endNode_2',
                  nodeType:'endNode',
                  // 拖拽后进行配置branch
                  action:'useGetLotteryEligibility',
                  branch:[
                    
                  ],
                  
                },
              ],
              
            },
            {
              name:'抽奖路径3',
              id:'businessNode_1_3',
              nodeType:'businessNode',
              action:'useGetLotteryEligibility',
              // 拖拽后进行配置branch
              branch:[
                {
                  name:'结束',
                  id:'endNode_3',
                  nodeType:'endNode',
                  action:'useGetLotteryEligibility',
                  // 拖拽后进行配置branch
                  branch:[
                    
                  ],
                  
                },
              ],
              
            },
          ],
          
        }
      ],
      
    }],
  }
} 